var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddVirtualColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.947 16a.955.955 0 0 1-.702-.286.956.956 0 0 1-.287-.703c0-.277.096-.511.287-.702a.955.955 0 0 1 .702-.287h5.075V1.978H8.947a.955.955 0 0 1-.702-.287.956.956 0 0 1-.287-.702c0-.278.096-.512.287-.703A.955.955 0 0 1 8.947 0h5.075c.548 0 1.014.193 1.4.578.385.386.578.852.578 1.4v12.044c0 .548-.193 1.014-.578 1.4a1.906 1.906 0 0 1-1.4.578H8.947zm-2.07-7.011H.99a.956.956 0 0 1-.703-.286A.956.956 0 0 1 0 8c0-.277.095-.512.286-.703a.956.956 0 0 1 .703-.286h5.889l-1.51-1.51a.918.918 0 0 1-.276-.675c0-.267.092-.497.275-.692a.927.927 0 0 1 .69-.305.941.941 0 0 1 .71.289l3.19 3.19A.957.957 0 0 1 10.25 8a.957.957 0 0 1-.292.692l-3.191 3.19a.918.918 0 0 1-.7.29.975.975 0 0 1-.7-.306.954.954 0 0 1-.267-.7c.005-.272.1-.5.284-.683l1.494-1.494z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVirtualColumn);
export default __webpack_public_path__ + "static/media/add-virtual-column.0f4c28709dce45b3985f6a4cf38e1a53.svg";
export { ForwardRef as ReactComponent };